import plansSlice from '.';

// eslint-disable-next-line import/prefer-default-export
export const { setPlans } = plansSlice.actions;
